import { render, staticRenderFns } from "./No14.vue?vue&type=template&id=f096b206&scoped=true"
import script from "./No14.vue?vue&type=script&lang=js"
export * from "./No14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f096b206",
  null
  
)

export default component.exports